module.exports = __webpack_public_path__ + "img/mob.997e2643.jpg";